// extracted by mini-css-extract-plugin
export var messageSideLeft = "_hf-1";
export var messageSideRight = "_hf-2";
export var orderLookupBubbleContainer = "_hf-0";
export var submitButton = "_hf-3";